import Vue from 'vue'
import FirebaseImg from './components/FirebaseImg.vue'
import Vuex from 'vuex'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import App from './App.vue'
import { router } from './helpers/router'
import { ToastProgrammatic as Toast } from 'buefy'
import store from './store'
import Axios from 'axios'
import i18n from './helpers/i18n'
import firebase from 'firebase'
import VeeValidate from 'vee-validate'
import '@mdi/font/css/materialdesignicons.css'
import './helpers/mixins/moduleConfiguration'
//import { email } from "vuelidate/lib/validators";

Vue.prototype.$http = Axios
Vue.prototype.$toast = Toast
Vue.prototype.$serverUrl = 'http://localhost:3000'

// eslint-disable-next-line no-unused-vars
const releaseConfig = {
  apiKey: 'AIzaSyDWbEQkQKZadml4AcG68fn3Ypgw4l9TyjM',
  authDomain: 'footwizardweb.firebaseapp.com',
  databaseURL: 'https://footwizardweb.firebaseio.com',
  projectId: 'footwizardweb',
  storageBucket: 'footwizardweb.appspot.com',
  messagingSenderId: '366862215724',
  appId: '1:366862215724:web:731d983e12bd5112257f89',
}

// eslint-disable-next-line no-unused-vars
const devConfig = {
  apiKey: 'AIzaSyDsO_N-8Mi7YwqGNUolXNNSjnyLGM29FgI',
  authDomain: 'footwizarddev.firebaseapp.com',
  databaseURL: 'https://footwizarddev.firebaseio.com',
  projectId: 'footwizarddev',
  storageBucket: 'footwizarddev.appspot.com',
  messagingSenderId: '932211682149',
  appId: '1:932211682149:web:3662a765427bbbf3f08f8c',
}

//firebase.initializeApp(releaseConfig)
firebase.initializeApp(devConfig)

Vue.component('FirebaseImg', FirebaseImg)

Vue.prototype.$db = firebase.firestore()
Vue.prototype.$storage = firebase.storage()
Vue.prototype.$functions = firebase.app().functions('europe-west1')

//TODO: Una volta sistemati mattere questa variabile nei file giusti
//compord: in compilazione
//invord: inviabile
//sendord: spedito
//proc_order: proc. ordine
//workord: in lavorazione
//waitord: in attesa di materiali
//standord: in standby
//segnord: segnalazione spedita
//segnreceiveord: segnreceiveord
//endord: endord
//courier: courier
//closed: chiuso
//deletedord: eliminato
Vue.prototype.$status = {
  tailored: [
    'compord',
    'invord',
    'sendord',
    'proc_order',
    'workord',
    'waitord',
    'standord',
    'endord',
    'courier',
    'segnreceiveord',
    'closed',
    'processed',
    'deletedord',
  ],
  fits: [
    'compord',
    'invord',
    'sendord',
    'proc_order',
    'workord',
    'standord',
    'endord',
    'courier',
    'segnreceiveord',
    'closed',
    'processed',
    'deletedord',
  ],
  modular: [
    'compord',
    'invord',
    'sendord',
    'proc_order',
    'workord',
    'standord',
    'endord',
    'courier',
    'segnreceiveord',
    'closed',
    'processed',
    'deletedord',
  ],
  insole: [
    'compord',
    'invord',
    'sendord',
    'proc_order',
    'workord',
    'standord',
    'endord',
    'courier',
    'segnreceiveord',
    'closed',
    'processed',
    'deletedord',
  ],
}

Vue.prototype.$statusActiveI12 = ['sendord', 'proc_order', 'workord', 'waitord', 'standord', 'endord', 'courier']

Vue.prototype.$statusActive = [
  'compord',
  'invord',
  'sendord',
  'proc_order',
  'workord',
  'waitord',
  'standord',
  'endord',
  'courier',
]
Vue.prototype.$statusActiveFits = [
  'compord',
  'invord',
  'sendord',
  'proc_order',
  'workord',
  'standord',
  'endord',
  'courier',
]

Vue.prototype.$statusClosed = ['closed', 'processed', 'segnreceiveord']

Vue.prototype.$availableMaterials = {
  tailored: [
    'Pel',
    'Acc',
    'Mor',
    'Pun',
    'Mod',
    'Mat',
    'Sug',
    'PaS',
    'Pat',
    'Moi',
    'Sup_plan',
    'Riv_plan',
    'Mez',
    'Pelo',
    'reinforcement',
  ],
  fits: ['Pel_F', 'Acc_F', 'All_F', 'Fog_F', 'Pun_F', 'Col_F', 'PaS_F', 'Pat_F'],
  modular: ['Pel_M', 'Rip_M', 'Fog_M', 'Pun_M', 'Col_M'],
  insole: ['Moi_I', 'Ric_plan_I', 'Rie_plan_I', 'Ins_I'],
}
Vue.prototype.$updateavailableMaterials = {}

Vue.prototype.$availableShoeType = ['high', 'low']

Vue.prototype.$availableSexType = ['man', 'woman', 'child', 'unisex']

Vue.prototype.$availableDime = ['p', 'g', 'gextra', 'dunadime', 'customerdime']

Vue.prototype.$shapeTableHeadersLow = {
  fits: ['size', 'ball', 'instep', 'instep_italy', 'heel', 'length', 'width', 'toe_height'],
  modular: ['size', 'ball', 'instep_italy', 'heel', 'length', 'width', 'toe_height'],
}

Vue.prototype.$shapeTableHeadersHigh = {
  fits: ['size', 'ball', 'instep', 'instep_italy', 'heel', 'end_tomaia', 'length', 'width', 'toe_height'],
  modular: ['size', 'ball', 'instep_italy', 'heel', 'length', 'width', 'toe_height'],
}

Vue.prototype.$addOns = {
  fits: [
    { name: 'add_instep', range: [0, 3, 6] },
    { name: 'add_fifthMeta', range: [0, 3, 6] },
    { name: 'add_toe', range: [0, 3, 6] },
    { name: 'add_firstMeta', range: [0, 3, 6] },
    { name: 'add_extraTotal', range: [0, 3, 6, 9] },
    { name: 'add_extraHeel', range: [0, 3, 6, 9] },
  ],
  modular: [
    { name: 'add_fingers', range: [0, 3, 6] },
    { name: 'add_firstMeta', range: [0, 3, 6] },
    { name: 'add_fifthMeta', range: [0, 3, 6] },
    { name: 'add_instep', range: [0, 3, 6] },
    { name: 'add_extraTotal', range: [0, 3] },
  ],
}

Vue.prototype.$modules = ['tailored', 'fits', 'modular', 'insole']

let globalData = new Vue({
  data: { $translateMode: false, $translationArray: [] },
})
Vue.mixin({
  computed: {
    $translateMode: {
      get: function() {
        return globalData.$data.$translateMode
      },
      set: function(newvalue) {
        globalData.$data.$translateMode = newvalue /*globalData.$data.$translationArray = [];*/
      },
    },
  },
})

Vue.prototype.$translate = function(stringToTranslate) {
  /*if (!globalData.$data.$translationArray.includes(stringToTranslate)) {
    globalData.$data.$translationArray.push(stringToTranslate);
  }
  console.log(globalData.$data.$translationArray.join("','"))*/

  if (globalData.$data.$translateMode) {
    return i18n.t(stringToTranslate) + ' (' + stringToTranslate + ') '
  } else {
    return i18n.t(stringToTranslate)
  }
}

Vue.prototype.$translateMaterial = function(material) {
  return material.translations && material.translations[i18n.locale]
    ? material.translations[i18n.locale]
    : material.commercial_name
}

Vue.prototype.$translateMaterialVariant = function(variant) {
  return variant.translations && variant.translations[i18n.locale] ? variant.translations[i18n.locale] : variant.name
}

Vue.use(Vuex)
Vue.use(Buefy)
i18n.locale = 'it'

Vue.config.productionTip = false
Vue.filter('capitalize', function(value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})
Vue.filter('uppercase', function(value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

const translatedMessages = {
  from1to100: () => {
    return i18n.t('from1to100_field')
    //return "Il campo deve essere compreso fra 1 e 100";
  },
  from15to80: () => {
    return i18n.t('from15to80_field')
    //return "Il campo deve essere compreso fra 15 e 80";
  },
  from5to130: () => {
    return i18n.t('from5to130_field')
    //return "Il campo deve essere compreso fra 15 e 80";
  },
  from70to500: () => {
    return i18n.t('from70to500_field')
    //return "Il campo deve essere compreso fra 15 e 80";
  },
  required: () => {
    return i18n.t('required_field')
    //return "Il campo " + field + " è richiesto";
  },
  numeric: () => {
    return i18n.t('numeric_field')
    //return "Il campo " + field + " deve essere numerico";
  },
  email: () => {
    return i18n.t('email_field')
    //return "Il campo " + field + " deve essere una email valida";
  },
  unique: () => {
    return i18n.t('no_duplicate_field')
    //return "Il " + field + " è già stato usato";
  },
  notnull: () => {
    return i18n.t('required_field')
    //return "Il campo " + field + " è richiesto";
  },
  threeneeding: () => {
    return i18n.t('threeneeding_field')
    //return "Sono necessari 3 file: .stl, .fms e .pln";
  },
  nooneSelected: () => {
    return i18n.t('required_field')
  },
  min_value: () => {
    return i18n.t('min_value')
  },
  max_value: (field, params) => {
    return i18n.t('max_value', { max: params[0] })
  },
  ext: () => {
    return i18n.t('upload_input')
  },
  decimal: () => {
    return i18n.t('decimal')
  },
  included: () => {
    return i18n.t('included')
  },
  integer: () => {
    return i18n.t('integer')
  },
  between: (header, valueRange) => {
    return i18n.t('between', { min: valueRange[0], max: valueRange[1] })
  },
  is: () => {
    return i18n.t('password_mismatch')
  },
}

Vue.use(VeeValidate, {
  inject: false,
  i18n,
  dictionary: {
    it: {
      attributes: i18n.messages.it,
      messages: translatedMessages,
    },
    en: {
      attributes: i18n.messages.en,
      messages: translatedMessages,
    },
    fr: {
      attributes: i18n.messages.fr,
      messages: translatedMessages,
    },
    dk: {
      attributes: i18n.messages.dk,
      messages: translatedMessages,
    },
    de: {
      attributes: i18n.messages.de,
      messages: translatedMessages,
    },
  },
})
